






















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import {
  buildTruckingAccountReceivableFormState,
  buildTruckingAccountReceivableProductState,
  SearchBuilder,
} from "@/builder";
import InvoicePrintModal from "@/components/InvoiceAr/InvoicePrintModal.vue";
import currencyFilter from "@/filters/currency.filter";
import { trimSpaceToUnderscore } from "@/helpers/common";
import { debounceProcess } from "@/helpers/debounce";
import {
  APagination,
  useArPrepayment,
  useBranch,
  useCalculator,
  useCoa,
  useContactData,
  useCurrency,
  useFindMasterType,
  useInvoiceAR,
  useMapMasterTypeToOptionAlt,
  usePreferences,
  useProduct,
  useRemoveRows,
  useSalesOrder,
  useTax,
  useTaxInvoice,
  useTaxRate,
  useTruckingAccountReceivable,
} from "@/hooks";
import { TruckingAccountReceivableMapper } from "@/mapper/TruckingAccountReceivable.mapper";
import MNotification from "@/mixins/MNotification.vue";
import { Option } from "@/models/class/option.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
  ONE,
  PAGE_SIZE_OPTIONS,
} from "@/models/constant/global.constant";
import { Pagination } from "@/models/constant/interface/common.interface";
import {
  DATE_FORMAT_YYYY_MM_DD,
  DEFAULT_DATE_FORMAT,
} from "@/models/constants/date.constant";
import {
  EnumInvoiceArStatus,
  InvoiceArStatus,
} from "@/models/enums/invoice.enum";
import { TAX_CALCULATION, TAX_TYPE } from "@/models/enums/tax.enum";
import { InvoicePrepaymentListResponseDto } from "@/models/interface/ar-prepayment";
import {
  AddressDataDto,
  ListContactDataDto,
} from "@/models/interface/contact-data";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import { ProductResponseDto } from "@/models/interface/master-product";
import { AccountingTaxResponseDto } from "@/models/interface/master-tax";
import { SalesOrderResponseDto } from "@/models/interface/sales-order";
import { SalesOrderHeaderData } from "@/models/interface/salesOrder.interface";
import { TaxBaseVariableParams } from "@/models/interface/tax-base-variable";
import { taxBaseVariableService } from "@/services/tax-base-variable.service";
import { LabelInValue } from "@/types";
import {
  RoundingUtils,
  StringUtils,
  TruckingAccountReceivableUtils,
} from "@/utils";
import {
  formatterNumber,
  formatterPercent,
  reverseFormatNumber,
  reverseFormatPercent,
} from "@/validator/globalvalidator";
import {
  TruckingAccountReceivableFormDiscountState,
  TruckingAccountReceivableFormPrepaymentLineState,
  TruckingAccountReceivableFormState,
  TruckingAccountReceivableFormStatusDetailInvoiceState,
  TruckingAccountReceivableProductState,
  TruckingInvoiceArCreateDto,
  TruckingInvoiceArUpdateDto,
} from "@interface/trucking-account-receivable";
import { FormModel } from "ant-design-vue";
import { Decimal } from "decimal.js-light";
import { Moment } from "moment";
import Vue from "vue";
import { mapState } from "vuex";
import FormTruckingInvoiceStatusView from "./FormTruckingInvoiceStatusView.vue";
import ModalTruckingInvoiceDiscount from "./ModalTruckingInvoiceDiscount.vue";

const NON_STOCKABLE = "Non Stockable";
const SERVICE = "Service";
const SALES_ORDER_TRUCKING = "Trucking";
const INDONESIA_RUPIAH = "IDR";

export default Vue.extend({
  name: "FormTruckingInvoice",
  components: {
    FormTruckingInvoiceStatusView,
    ModalTruckingInvoiceDiscount,
    InvoicePrintModal,
  },
  mixins: [MNotification],
  props: {
    invoiceId: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapState({
      storeBaseDecimalPlace: (st: any) =>
        st.preferenceStore.baseDecimalPlace as number,
    }),
    isIdr(): boolean {
      return INDONESIA_RUPIAH === this.formState.currency?.label;
    },
    title() {
      if (this.invoiceId)
        return this.$t("common.edit-text", {
          text: this.$t("lbl_invoice_ar"),
        });
      return this.$t("common.create-text", {
        text: this.$t("lbl_invoice_ar"),
      });
    },
    totalUsedPrepayment(): number {
      return TruckingAccountReceivableUtils.countTotalUsedPrepayment(
        this.formState.prepayment.prepaymentLines
      );
    },
    totalGross(): number {
      return TruckingAccountReceivableUtils.countTotalGross(
        this.formState.products
      );
    },
    totalTax(): number {
      return TruckingAccountReceivableUtils.countTotalTax(
        this.formState.products
      );
    },
    grandTotal(): number {
      const total = this.formState.products.reduce(
        (total: number, product: TruckingAccountReceivableProductState) => {
          return new Decimal(total).plus(product.subtotal).toNumber();
        },
        0
      );
      return total;
    },
    allowCancel(): boolean {
      const status: Uppercase<EnumInvoiceArStatus>[] = ["UNPAID"];
      return status.includes(
        trimSpaceToUnderscore(
          this.formState.status
        ) as Uppercase<EnumInvoiceArStatus>
      );
    },
    allowPostJournal(): boolean {
      const status: Uppercase<EnumInvoiceArStatus>[] = ["UNPAID"];
      return (
        status.includes(
          trimSpaceToUnderscore(
            this.formState.status
          ) as Uppercase<EnumInvoiceArStatus>
        ) && !this.formState.journalId
      );
    },
    allowPrint(): boolean {
      const status = [
        "NEED_APPROVAL",
        "DELIVERED",
        "REJECTED",
        "CANCELLED",
        "UNPAID",
        "PARTIAL_PAID",
        "FULLY_PAID",
        "RETURNED",
      ];
      return status.includes(trimSpaceToUnderscore(this.formState.status));
    },
    allowUpdate(): boolean {
      const status = ["DRAFT", "NEED_APPROVAL", "DELIVERED", "UNPAID"];
      return (
        status.includes(trimSpaceToUnderscore(this.formState.status)) &&
        !this.formState.journalId
      );
    },
    allowSubmit(): boolean {
      const status: Uppercase<EnumInvoiceArStatus>[] = ["DRAFT"];
      return (
        !this.invoiceId ||
        status.includes(
          trimSpaceToUnderscore(
            this.formState.status
          ) as Uppercase<EnumInvoiceArStatus>
        )
      );
    },
    allowReject(): boolean {
      const status = ["NEED_APPROVAL"];
      return status.includes(trimSpaceToUnderscore(this.formState.status));
    },
    isTaxInclusive(): boolean {
      return this.formState.taxCalculation === TAX_CALCULATION.INCLUSIVE;
    },
    isInclusiveNonLuxury(): boolean {
      return (this.isTaxInclusive as boolean) && !this.formState.isLuxury;
    },
    isInclusiveLuxury(): boolean {
      return this.isTaxInclusive && this.formState.isLuxury;
    },
    allowRounding(): boolean {
      const roundableStatus = [
        InvoiceArStatus.DRAFT,
        InvoiceArStatus.NEED_APPROVAL,
        InvoiceArStatus.DELIVERED,
      ].map(trimSpaceToUnderscore);
      return (
        !this.invoiceId ||
        roundableStatus.includes(trimSpaceToUnderscore(this.formState.status))
      );
    },
    isRoundingApplied(): boolean {
      return (
        this.formState.products.length > 0 &&
        this.formState.products.every(product => product.taxAmount.isInteger())
      );
    },
    roundingButtonText(): string {
      return this.isRoundingApplied
        ? (this.$t("lbl_rounding_applied") as string)
        : (this.$t("lbl_apply_rounding") as string);
    },
    roundingButtonIcon(): string | undefined {
      return this.isRoundingApplied ? "check" : undefined;
    },
    columns() {
      return [
        {
          title: this.$t("lbl_document_reference"),
          dataIndex: "docReference",
          scopedSlots: { customRender: "docReference" },
        },
        {
          title: this.$t("lbl_shipment_id"),
          key: "shipmentId",
          scopedSlots: { customRender: "shipmentId" },
        },
        {
          title: this.$t("lbl_unit_code"),
          key: "unitCode",
          scopedSlots: { customRender: "unitCode" },
        },
        {
          title: this.$t("lbl_serial_number"),
          dataIndex: "serialNumber",
          customRender: (text: string) => text ?? "-",
        },
        {
          title: this.$t("lbl_equipment"),
          dataIndex: "equipment",
          customRender: (text: string) => text ?? "-",
        },
        {
          title: this.$t("lbl_brand"),
          dataIndex: "brand",
          customRender: (text: string) => text ?? "-",
        },
        {
          title: this.$t("lbl_type"),
          dataIndex: "type",
          customRender: (text: string) => text ?? "-",
        },
        {
          title: this.$t("lbl_spec"),
          dataIndex: "spec",
          customRender: (text: string) => text ?? "-",
        },
        {
          title: this.$t("lbl_sales_name"),
          key: "salesPerson",
          scopedSlots: { customRender: "salesPerson" },
        },
        {
          title: this.$t("lbl_price"),
          dataIndex: "price",
          scopedSlots: { customRender: "price" },
        },
        {
          title: this.$t("lbl_quantity"),
          dataIndex: "quantity",
          customRender: text => currencyFilter(text),
        },
        {
          title: this.$t("lbl_gross_value"),
          dataIndex: "grossAfterDiscount",
          customRender: (_, record: TruckingAccountReceivableProductState) =>
            currencyFilter(record.grossAfterDiscount.toNumber()),
        },
        {
          title: this.$t("lbl_revenue_account"),
          key: "revenueAccount",
          scopedSlots: { customRender: "revenueAccount" },
        },
        {
          title: this.$t("lbl_base_amount"),
          key: "baseAmount",
          customRender: (
            _: any,
            record: TruckingAccountReceivableProductState
          ) => currencyFilter(record.baseAmount.toNumber()),
        },
        {
          title: this.$t("lbl_include_pph"),
          key: "includePph",
          scopedSlots: { customRender: "includePph" },
        },
        {
          title: this.$t("lbl_income_tax"),
          key: "incomeTax",
          scopedSlots: { customRender: "incomeTax" },
        },
        {
          title: this.$t("lbl_tax_code"),
          key: "taxCode",
          scopedSlots: { customRender: "taxCode" },
        },
        ...(this.isInclusiveNonLuxury
          ? [
              {
                title: this.$t("lbl_inclusive_tax_code"),
                dataIndex: "inclusiveTax",
                key: "inclusiveTax",
                scopedSlots: { customRender: "inclusiveTax" },
              },
            ]
          : []),
        {
          title: this.$t("lbl_tax_amount"),
          key: "taxAmount",
          customRender: (_, record: TruckingAccountReceivableProductState) =>
            currencyFilter(record.taxAmount.toNumber()),
        },
        {
          title: this.$t("lbl_sub_total"),
          key: "subtotal",
          customRender: (_, record: TruckingAccountReceivableProductState) =>
            currencyFilter(record.subtotal.toNumber()),
        },
        {
          title: this.$t("lbl_description"),
          dataIndex: "description",
          scopedSlots: { customRender: "description" },
        },
        {
          key: "more",
          scopedSlots: { customRender: "more" },
        },
      ];
    },
  },
  data() {
    this.onSearchBranch = debounceProcess(this.onSearchBranch, 500);
    this.onSearchUnitCode = debounceProcess(this.onSearchUnitCode, 500);
    this.onSearchCustomer = debounceProcess(this.onSearchCustomer, 500);
    this.onSearchCurrency = debounceProcess(this.onSearchCurrency, 500);
    this.onSearchSalesOrder = debounceProcess(this.onSearchSalesOrder, 500);
    this.onSearchAssignee = debounceProcess(this.onSearchAssignee, 500);
    this.onSearchSalesPerson = debounceProcess(this.onSearchSalesPerson, 500);
    this.onSearchTaxCode = debounceProcess(this.onSearchTaxCode, 500);
    this.onSearchInclusiveTaxCode = debounceProcess(
      this.onSearchInclusiveTaxCode,
      500
    );
    this.onSearchIncomeTax = debounceProcess(this.onSearchIncomeTax, 500);
    this.onSearchCustomerTaxType = debounceProcess(
      this.onSearchCustomerTaxType,
      500
    );
    this.onSearchRevenueAccount = debounceProcess(
      this.onSearchRevenueAccount,
      500
    );
    this.onSearchReceivableAccount = debounceProcess(
      this.onSearchReceivableAccount,
      500
    );
    return {
      DEFAULT_DATE_FORMAT,
      PAGE_SIZE_OPTIONS,
      form: this.$refs.form as FormModel,
      formState: buildTruckingAccountReceivableFormState(),
      schemaValidation: {
        invoiceType: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
        invoiceSource: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
        invoiceDate: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
        branch: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
        currency: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
        customer: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
        shippingAddress: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
        billingAddress: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
        salesOrders: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
        taxCalculation: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
        termOfPayment: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
        receivableAccount: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
        assignee: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
        description: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
        customerTaxType: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
        taxInvoiceDate: [
          { required: true, message: this.$t("lbl_validation_required_error") },
        ],
      },
      salesInclusiveTax: {
        id: "",
        name: "",
        rate: 0,
      },
      invoiceTypeOptions: [] as Option[],
      branchOptions: [] as Option[],
      currencyOptions: [] as Option[],
      salesOrderOptions: [] as Option<SalesOrderHeaderData>[],
      customerOptions: [] as Option[],
      customerShippingAddressOptions: [] as Option[],
      customerBillingAddressOptions: [] as Option[],
      taxCalculationOptions: [] as Option[],
      termOfPaymentOptions: [] as Option[],
      receivableAccountOptions: [] as Option[],
      assigneeOptions: [] as Option<ListContactDataDto>[],
      salesPersonOptions: [] as Option[],
      revenueAccountOptions: [] as Option[],
      incomeTaxOptions: [] as Option[],
      taxCodeOptions: [] as Option<AccountingTaxResponseDto>[],
      inclusiveTaxCodeOptions: [] as Option<AccountingTaxResponseDto>[],
      customerTaxTypeOptions: [] as Option[],
      unitCodeOptions: [] as Option<ProductResponseDto>[],
      selectedRowKeys: [] as string[],
      prepaymentPagination: {
        page: DEFAULT_PAGE,
        limit: DEFAULT_PAGE_SIZE,
      },
      dtPrepayment: {
        currentPage: 0,
        data: [],
        totalElements: 0,
        totalPages: 0,
      } as Pagination<InvoicePrepaymentListResponseDto>,
      loading: {
        invoiceType: false,
        branch: false,
        currency: false,
        salesOrder: false,
        customer: false,
        taxCalculation: false,
        termOfPayment: false,
        receivableAccount: false,
        assignee: false,
        generate: false,
        customerTaxType: false,
        taxInvoiceNumber: false,
        prepayment: false,
        cancel: false,
        postJournal: false,
        rounding: false,
        update: false,
        submit: false,
        reject: false,
      },
      modalStatus: {
        show: false,
        title: "",
        data: [] as TruckingAccountReceivableFormStatusDetailInvoiceState[],
      },
      modalDiscount: {
        show: false,
        data: {
          unitCode: "",
          serialNumber: "",
          equipment: "",
          brand: "",
          type: "",
          spec: "",
          baseAmount: 0,
          discountAmount: 0,
          discountPercent: 0,
        } as TruckingAccountReceivableFormDiscountState,
      },
      modalPrint: {
        show: false,
      },
      prepaymentColumns: [
        {
          title: this.$t("common.number-text", {
            text: this.$t("lbl_invoice_prepayment"),
          }),
          key: "invoiceNumber",
          scopedSlots: { customRender: "invoiceNumber" },
        },
        {
          title: this.$t("lbl_applied_amount"),
          key: "appliedAmount",
          scopedSlots: { customRender: "appliedAmount" },
        },
        {
          title: this.$t("lbl_description"),
          dataIndex: "description",
          customRender: (text: string) => text || "-",
        },
        {
          key: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
    };
  },
  async created() {
    await this.getDefaultSalesInclusiveRate();
  },
  mounted() {
    this.form = this.$refs.form as FormModel;
    this.getBranchList();
    this.getCustomerList();
    this.getCurrencyList();
    this.getTaxCalculationList();
    this.getTermOfPaymentList();
    this.getAssigneeList();
    this.getSalesPersonList();
    this.getRevenueAccountList();
    this.getIncomeTaxList();
    this.getTaxCodeList();
    this.getCustomerTaxTypeList();
    this.getUnitCodeList();
    this.getInvoiceType();
    this.getInclusiveTaxCodeList();
    if (this.invoiceId) {
      this.getDetail(this.invoiceId);
    } else {
      this.setDefaultCurrency();
      this.setDefaultReceivableAccount();
      this.setDefaultAssignee();
    }
    if (this.formState.currency) {
      this.findReceivableAccount(this.formState.currency.label);
    }
  },
  methods: {
    reverseFormatNumber,
    formatterNumber,
    reverseFormatPercent,
    formatterPercent,
    async getDetail(invoiceId: string) {
      const { findById } = useTruckingAccountReceivable();
      const response = await findById(invoiceId);
      const detailContact = await this.getContactDetail(response.customerId);
      this.setAddressOptions(detailContact.addressDataList);
      this.formState = TruckingAccountReceivableMapper.toFormState(response);
      const variable = await this.getTaxBaseVariable({
        transactionDate: this.formState.invoiceDate.format(
          DATE_FORMAT_YYYY_MM_DD
        ),
        isLuxury: this.formState.isLuxury,
      });
      this.formState.taxBaseVariable = variable;
      this.countTotalFooter(this.formState);
      this.findCustomerPrepayment({
        customerId: this.formState.customer?.key,
        branchId: this.formState.branch?.key,
        currencyCode: this.formState.currency?.label,
      });
      this.findSalesOrders({
        branch: this.formState.branch?.key,
        customer: this.formState.customer?.key,
        currency: this.formState.currency?.label,
      });
      this.findReceivableAccount(response.currency);
    },
    handlePrint() {
      this.modalPrint.show = true;
    },
    async handlePostJournal() {
      const { postJournalInvoiceAr } = useInvoiceAR();
      try {
        this.loading.postJournal = true;
        const response = await postJournalInvoiceAr(this.docId);
        this.showNotifSuccess("notif_update_success", {
          documentNumber: response.journalNo,
        });
        this.$router.push({ name: "trucking.account-receivable.list" });
      } finally {
        this.loading.postJournal = false;
      }
    },
    async handleCancelInvoice() {
      const { cancelInvoiceAr } = useInvoiceAR();
      try {
        this.loading.cancel = true;
        const response = await cancelInvoiceAr(this.invoiceId);
        this.showNotifSuccess("notif_cancel_success", {
          documentNumber: response.documentNumber,
        });
        this.$router.push({ name: "trucking.account-receivable.list" });
      } catch (error) {
        this.showNotifError("notif_cancel_fail");
      } finally {
        this.loading.cancel = false;
      }
    },
    async validateForm(key: "update" | "submit") {
      try {
        await this.form.validate();

        if (key === "update" && this.invoiceId) {
          this.updateInvoiceAr(this.invoiceId, this.formState);
        } else if (key === "submit" && this.invoiceId && this.allowSubmit) {
          this.submitInvoiceAr(this.invoiceId, this.formState);
        } else {
          this.createInvoiceAr(this.formState);
        }
      } catch (error) {
        this.showNotifError("notif_validation_error");
      }
    },
    async createInvoiceAr(state: TruckingAccountReceivableFormState) {
      const { createInvoiceAr: create } = useTruckingAccountReceivable();
      try {
        const request: TruckingInvoiceArCreateDto =
          TruckingAccountReceivableMapper.toInvoiceArCreateDto(state);
        this.loading.submit = true;
        const response = await create(request);
        this.$router.push({ name: "trucking.account-receivable.list" });
        this.showNotifSuccess("notif_create_success", {
          documentNumber: response.documentNumber,
        });
      } catch (error) {
        this.showNotifError("notif_create_fail");
      } finally {
        this.loading.submit = false;
      }
    },
    async submitInvoiceAr(
      invoiceId: string,
      state: TruckingAccountReceivableFormState
    ) {
      const { submitInvoiceAr: submit } = useTruckingAccountReceivable();
      try {
        const request: TruckingInvoiceArUpdateDto =
          TruckingAccountReceivableMapper.toInvoiceArUpdateDto(state);
        this.loading.submit = true;
        const response = await submit(invoiceId, request);
        this.$router.push({ name: "trucking.account-receivable.list" });
        this.showNotifSuccess("notif_submit_success", {
          documentNumber: response.documentNumber,
        });
      } catch (error) {
        this.showNotifError("notif_submit_fail");
      } finally {
        this.loading.submit = false;
      }
    },
    async updateInvoiceAr(
      invoiceId: string,
      state: TruckingAccountReceivableFormState
    ) {
      const { updateInvoiceAr: update } = useTruckingAccountReceivable();
      try {
        const request: TruckingInvoiceArUpdateDto =
          TruckingAccountReceivableMapper.toInvoiceArUpdateDto(state);
        this.loading.update = true;
        const response = await update(invoiceId, request);
        this.$router.push({ name: "trucking.account-receivable.list" });
        this.showNotifSuccess("notif_update_success", {
          documentNumber: response.documentNumber,
        });
      } catch (error) {
        this.showNotifError("notif_update_fail");
      } finally {
        this.loading.update = false;
      }
    },
    async handleRejectInvoice() {
      const { rejectInvoiceAr } = useInvoiceAR();
      try {
        this.loading.reject = true;
        const response = await rejectInvoiceAr(this.invoiceId);
        this.showNotifSuccess("notif_reject_success", {
          documentNumber: response.documentNumber,
        });
        this.$router.push({ name: "trucking.account-receivable.list" });
      } catch (error) {
        this.showNotifError("notif_reject_fail");
      } finally {
        this.loading.reject = false;
      }
    },
    async getInvoiceType() {
      const PREPAYMENT = "PREPAYMENT";
      const CREDIT_MEMO = "CREDIT_MEMO";
      try {
        this.loading.invoiceType = true;
        const response = await useFindMasterType("INVOICE_AR_TYPE");
        const filtered = response.filter(
          ({ value }) =>
            trimSpaceToUnderscore(value) !== PREPAYMENT &&
            trimSpaceToUnderscore(value) !== CREDIT_MEMO
        );
        this.invoiceTypeOptions = filtered.map<Option>(item => ({
          label: item.value,
          value: item.value,
          key: item.value,
        }));

        // new document
        if (!this.invoiceId) {
          this.formState.invoiceType = filtered[0]?.value;
        }
      } finally {
        this.loading.invoiceType = false;
      }
    },
    async getCustomerList(
      params: RequestQueryParamsModel = new RequestQueryParams()
    ) {
      const { findCustomers, toOptionsCustomer } = useContactData();
      try {
        this.loading.customer = true;
        const response = await findCustomers(params);
        this.customerOptions = toOptionsCustomer(response.data);
      } finally {
        this.loading.customer = false;
      }
    },
    onSearchCustomer(value?: string) {
      const { filterBy } = useContactData();
      const params = new RequestQueryParams();
      if (value) {
        params.search = filterBy({ firstName: value, lastName: value });
      }
      this.getCustomerList(params);
    },
    async onChangeCustomer(value: LabelInValue) {
      this.handleResetSalesOrder();
      this.handleResetPrepayment();
      this.formState.customerTaxType = "";
      this.formState.taxRegistrationName = "";
      this.formState.taxRegistrationNumber = "";
      this.formState.termOfPayment = undefined;
      this.formState.shippingAddress = undefined;
      this.formState.billingAddress = undefined;

      // get sales orders
      this.findSalesOrders({
        branch: this.formState.branch?.key,
        currency: this.formState.currency?.label,
        customer: value.key,
      });

      // get customer prepayment
      this.findCustomerPrepayment({
        customerId: value.key,
        branchId: this.formState.branch?.key,
        currencyCode: this.formState.currency?.label,
      });

      try {
        const response = await this.getContactDetail(value.key);
        this.formState.termOfPayment = response.top;

        // set customer tax registration
        if (response.taxRegisName && response.taxRegisNumber) {
          this.setCustomerTaxRegistration(
            response.taxRegisNumber,
            response.taxRegisName,
            response.addressDataList
          );
        }

        // set customer tax type (customer tax invoice code)
        if (response.customerData.taxInvoiceCode) {
          this.formState.customerTaxType = response.customerData.taxInvoiceCode;
        }

        // set customer shipping and billing address
        if (
          response.addressDataList &&
          Array.isArray(response.addressDataList)
        ) {
          this.setDefaultAddress(response.addressDataList);
          this.setAddressOptions(response.addressDataList);
        }
      } catch (error: any) {
        throw new Error(error);
      }
    },
    setAddressOptions(addresses: AddressDataDto[]) {
      const { toBillToAddressOptions, toShipToAddressOptions } =
        useContactData();
      this.customerShippingAddressOptions = toShipToAddressOptions(addresses);
      this.customerBillingAddressOptions = toBillToAddressOptions(addresses);
    },
    setDefaultAddress(addresses: AddressDataDto[]) {
      const { getDefaultShipToAddress, getDefaultBillToAddress } =
        useContactData();
      this.formState.billingAddress = getDefaultBillToAddress(addresses);
      this.formState.shippingAddress = getDefaultShipToAddress(addresses);
    },
    /**
     * @param taxInvoiceCode customer tax invoice code
     * @example 010
     */
    async setTaxInvoiceNumber(taxInvoiceCode: string) {
      if (
        this.formState.taxCalculation === TAX_CALCULATION.NONE ||
        !this.formState.invoiceDate
      ) {
        return;
      }
      const { findInvoiceCode } = useInvoiceAR();
      const params = {
        taxHasBeenUploaded: String(this.formState.taxIsUploaded),
        invoiceDate: this.formState.invoiceDate.format(DATE_FORMAT_YYYY_MM_DD),
        taxInvoiceSerialNumber: this.formState.taxInvoiceNumber,
      };
      try {
        this.formState.taxInvoiceNumber = "";
        this.loading.taxInvoiceNumber = true;
        const response = await findInvoiceCode(taxInvoiceCode, params);
        this.formState.taxInvoiceNumber = response;
      } finally {
        this.loading.taxInvoiceNumber = false;
      }
    },
    setCustomerTaxRegistration(
      taxRegistrationNumber: string,
      taxRegistrationName: string,
      addresses: AddressDataDto[]
    ) {
      if (taxRegistrationNumber === " " || taxRegistrationNumber === "-") {
        const data = addresses.find(
          item => item.idCardNumber && item.idCardNumber !== "-"
        );
        this.formState.taxRegistrationNumber = data?.idCardNumber ?? "";
      } else {
        this.formState.taxRegistrationNumber = taxRegistrationNumber ?? "";
      }

      if (taxRegistrationName !== " " && taxRegistrationName !== "-") {
        this.formState.taxRegistrationName = taxRegistrationName;
      }
    },
    async getContactDetail(customerId: string) {
      const { findOne } = useContactData();
      return findOne(customerId);
    },
    async getBranchList(params?: RequestQueryParamsModel) {
      const { findAll, toOptions } = useBranch();
      try {
        this.loading.branch = true;
        const response = await findAll(params);
        this.branchOptions = toOptions(response.data);
      } finally {
        this.loading.branch = false;
      }
    },
    onSearchBranch(value?: string) {
      const { searchBy } = useBranch();
      const params = new RequestQueryParams();
      if (value) {
        params.search = searchBy({ name: value });
      }
      this.getBranchList(params);
    },
    onChangeBranch(value: LabelInValue) {
      this.handleResetSalesOrder();
      this.handleResetPrepayment();
      this.findCustomerPrepayment({
        customerId: this.formState.customer?.key,
        branchId: value.key,
        currencyCode: this.formState.currency?.label,
      });
    },
    async getCurrencyList(params?: RequestQueryParamsModel) {
      const { findList, toOptionsNew } = useCurrency();
      try {
        this.loading.currency = true;
        const response = await findList(params);
        this.currencyOptions = toOptionsNew(response.data);
      } finally {
        this.loading.currency = false;
      }
    },
    onSearchCurrency(value?: string) {
      const { searchBy } = useCurrency();
      const params = new RequestQueryParams();
      if (value) {
        params.search = searchBy({ code: value });
      }
      this.getCurrencyList(params);
    },
    async onChangeCurrency(value: LabelInValue) {
      this.formState.currencyRates = ONE;
      this.handleResetSalesOrder();
      this.formState.receivableAccount = undefined;
      this.handleResetPrepayment();

      // get currency rates
      if (value) {
        try {
          const rates: number = await this.getCurrencyRates(value.label);
          this.formState.currencyRates = rates;
        } catch {
          this.formState.currencyRates = ONE;
        }
      }

      // get sales order
      if (this.formState.branch && value && this.formState.customer) {
        this.findSalesOrders({
          branch: this.formState.branch.key,
          customer: this.formState.customer.key,
          currency: value.label,
        });

        // get receivable account
        this.getDefaultReceivableAccount(value.label).then(response => {
          if (!response) return;
          this.formState.receivableAccount = {
            key: response.value,
            label: response.name,
          };
        });

        this.findCustomerPrepayment({
          customerId: this.formState.customer?.key,
          branchId: this.formState.branch?.key,
          currencyCode: value.label,
        });
      }
    },
    findSalesOrders(payload: {
      branch: string | undefined;
      customer: string | undefined;
      currency: string | undefined;
      documentNumber?: string;
    }) {
      if (!payload.branch || !payload.customer || !payload.currency) {
        this.formState.salesOrderOptions = [];
        return;
      }
      const params = new RequestQueryParams();
      const searchByBranchAndCustomerAndCurrencyCodeAndSalesType =
        new SearchBuilder()
          .push(["branch.secureId", payload.branch])
          .and()
          .push(["customer.secureId", payload.customer])
          .and()
          .push(["priceCurrency.currencyCode", payload.currency], {
            like: "both",
          })
          .and()
          .push(["salesType", SALES_ORDER_TRUCKING])
          .build();
      const defaultQuery = [
        searchByBranchAndCustomerAndCurrencyCodeAndSalesType,
      ];

      if (payload.documentNumber) {
        const searchByDocumentNumber = new SearchBuilder()
          .push(["documentNumber", payload.documentNumber], { like: "both" })
          .build();
        defaultQuery.push(searchByDocumentNumber);
      }

      params.search = defaultQuery.join(SearchBuilder.AND);
      this.getSalesOrderList(params);
    },
    onSearchSalesOrder(value?: string) {
      this.findSalesOrders({
        branch: this.formState.branch?.key,
        customer: this.formState.customer?.key,
        currency: this.formState.currency?.label,
        documentNumber: value,
      });
    },
    async getSalesOrderList(params?: RequestQueryParamsModel) {
      const { findAvailableSalesOrder } = useSalesOrder();
      try {
        this.loading.salesOrder = true;
        const response = await findAvailableSalesOrder(params);
        this.salesOrderOptions = response.data.map(item => ({
          key: item.id,
          label: item.documentNumber,
          value: item.id,
          meta: item,
        }));
      } finally {
        this.loading.salesOrder = false;
      }
    },
    async getCurrencyRates(currencyCode: string): Promise<number> {
      const { findBaseCurrency } = usePreferences();
      const { findConversion } = useCurrency();
      const baseCurrency = findBaseCurrency();
      if (!baseCurrency) return ONE;
      const conversion = await findConversion(baseCurrency.name, currencyCode);
      const [currencyRates] = conversion.data;
      return currencyRates?.rate ?? ONE;
    },
    async getDefaultReceivableAccount(
      currencyCode: string
    ): Promise<{ value: string; name: string } | null> {
      const { findByKey } = usePreferences();
      const { findAllChildAccount } = useCoa();

      if (currencyCode === INDONESIA_RUPIAH) {
        const response = findByKey("trucking_receivable_account");
        if (response && response.value) {
          return { value: response.value, name: response.name };
        }
      } else {
        const params = new RequestQueryParams();
        params.search = new SearchBuilder()
          .push(["parentAccount.code", "110202"], { like: "end" })
          .and()
          .push(["currency.currencyCode", currencyCode])
          .build();
        const response = await findAllChildAccount(params);
        const [account] = response.data;

        if (!account) return null;

        return {
          value: account.id,
          name: `${account.code} - ${account.description}`,
        };
      }

      return null;
    },
    onDeselectSalesOrder(value: LabelInValue) {
      const products: TruckingAccountReceivableProductState[] = [];
      for (const product of this.formState.products) {
        if (
          product.salesOrderLineId &&
          product.salesOrderLineId === value.key
        ) {
          this.formState.deletedInvoiceARLine.push(value);
        }
        if (product.salesOrderLineId !== value.key) {
          products.push(product);
        }
      }
      this.formState.products = products;

      this.countProductPrice({
        products: this.formState.products,
        taxCalculation: this.formState.taxCalculation,
        additionalDiscount: this.formState.discountAmount,
        totalPrepaymentUsed: this.totalUsedPrepayment,
        isLuxury: this.formState.isLuxury,
        taxBaseVariable: this.formState.taxBaseVariable,
      });
      this.countTotalFooter(this.formState);
    },
    async getTaxCalculationList() {
      try {
        this.loading.taxCalculation = true;
        const response = await useFindMasterType("TAX_CALCULATION");
        this.taxCalculationOptions = useMapMasterTypeToOptionAlt(response);
      } finally {
        this.loading.taxCalculation = false;
      }
    },
    async getTermOfPaymentList() {
      try {
        this.loading.termOfPayment = true;
        const response = await useFindMasterType("TOP");
        this.termOfPaymentOptions = useMapMasterTypeToOptionAlt(response);
      } finally {
        this.loading.termOfPayment = false;
      }
    },
    async getReceivableAccountList(params?: RequestQueryParamsModel) {
      const { findAllChildAccount, toOptions } = useCoa();
      try {
        this.loading.receivableAccount = true;
        const response = await findAllChildAccount(params);
        this.receivableAccountOptions = toOptions(response.data);
      } catch {
        this.receivableAccountOptions = [];
      } finally {
        this.loading.receivableAccount = false;
      }
    },
    onSearchReceivableAccount(value?: string) {
      if (this.formState.currency) {
        this.findReceivableAccount(this.formState.currency.label, value);
      }
    },
    findReceivableAccount(currencyCode: string, search?: string) {
      const { filterBy } = useCoa();
      const params = new RequestQueryParams();
      const searchByCurrency = new SearchBuilder()
        .push(["parentAccount.code", "110201"], { like: "end" })
        .and()
        .push(["currency.currencyCode", currencyCode], { like: "both" })
        .build();
      const queries: string[] = [searchByCurrency];
      if (search) {
        queries.unshift(filterBy({ code: search, description: search }));
      }
      params.search = queries.join(SearchBuilder.AND);
      this.getReceivableAccountList(params);
    },
    setDefaultCurrency() {
      const { findBaseCurrency } = usePreferences();
      const response = findBaseCurrency();
      if (response && response.value) {
        this.formState.currency = {
          key: response.value,
          label: response.name,
        };
      }
    },
    async setDefaultReceivableAccount() {
      if (!this.formState.currency) return;

      try {
        const response = await this.getDefaultReceivableAccount(
          this.formState.currency.label
        );
        if (!response) return;

        this.formState.receivableAccount = {
          key: response.value,
          label: response.name,
        };
      } catch (error) {
        this.formState.receivableAccount = undefined;
      }
    },
    async getAssigneeList(
      params: RequestQueryParamsModel = new RequestQueryParams()
    ) {
      const { findAllEmployee } = useContactData();
      try {
        this.loading.assignee = true;
        const response = await findAllEmployee(params);
        this.assigneeOptions = response.data.map(item => ({
          label: item.employeePosition,
          key: item.id,
          value: item.id,
          meta: item,
        }));
      } finally {
        this.loading.assignee = false;
      }
    },
    onSearchAssignee(value?: string) {
      const { filterBy } = useContactData();
      const params = new RequestQueryParams();
      if (value) {
        params.search = filterBy({ firstName: value, lastName: value });
      }
      this.getAssigneeList(params);
    },
    setDefaultAssignee() {
      const { findByKey } = usePreferences();
      const response = findByKey("trucking_assignee");
      if (response && response.value) {
        this.formState.assignee = {
          label: response.name,
          key: response.value,
        };
      }
    },
    async handleGenerate() {
      const { findById } = useSalesOrder();
      const salesOrders: Promise<SalesOrderResponseDto>[] =
        this.formState.salesOrders.map((item: LabelInValue) =>
          findById(item.key)
        );
      try {
        this.loading.generate = true;
        const response = await Promise.all(salesOrders);
        const taxTypes = new Set();
        const luxuries = new Set();

        for (const doc of response) {
          taxTypes.add(doc.taxCalculation);
          luxuries.add(doc.isLuxury);
        }

        if (taxTypes.size > ONE) {
          this.showNotifWarning("notif_document_has_different_tax_type");
          return;
        }

        if (luxuries.size > ONE) {
          this.showNotifWarning("notif_document_has_different_luxury_flag");
          return;
        }

        for (const detail of response) {
          const products: TruckingAccountReceivableProductState[] =
            TruckingAccountReceivableMapper.toInvoiceProductsState(detail);
          this.formState.products.push(...products);
        }
        const [doc] = response;
        if (
          StringUtils.compare(doc.taxCalculation, TAX_CALCULATION.INCLUSIVE) &&
          !doc.isLuxury
        ) {
          this.setDefaultRowsSalesInclusiveRate();
        }
        this.formState.isLuxury = doc.isLuxury;
        this.formState.taxCalculation = doc.taxCalculation;
        this.countProductPrice({
          products: this.formState.products,
          taxCalculation: this.formState.taxCalculation,
          additionalDiscount: this.formState.discountAmount,
          totalPrepaymentUsed: this.totalUsedPrepayment,
          isLuxury: this.formState.isLuxury,
          taxBaseVariable: this.formState.taxBaseVariable,
        });
        this.countTotalFooter(this.formState);
      } finally {
        this.loading.generate = false;
      }
    },
    async fetchSalesPersonList(
      params: RequestQueryParamsModel = new RequestQueryParams()
    ) {
      const { findSales, toOptions } = useContactData();
      try {
        const response = await findSales(params);
        return toOptions(response.data);
      } catch (error) {
        return [];
      }
    },
    async getSalesPersonList() {
      this.salesPersonOptions = await this.fetchSalesPersonList();
    },
    async onSearchSalesPerson(
      record: TruckingAccountReceivableProductState,
      value?: string
    ) {
      const { filterBy } = useContactData();
      record.isSearchSalesPerson = true;
      const params = new RequestQueryParams();
      if (value) {
        params.search = filterBy({ firstName: value, lastName: value });
      }
      record.loadingSalesPerson = true;
      record.salesPersonOptions = await this.fetchSalesPersonList(params);
      record.loadingSalesPerson = false;
    },
    async fetchRevenueAccount(
      params: RequestQueryParamsModel = new RequestQueryParams()
    ) {
      const { findAllChildAccount, toOptions } = useCoa();
      const ACCOUNT_TYPE = "Pendapatan";
      const defaultQueries: string[] = [
        new SearchBuilder()
          .push(["accountType.name", ACCOUNT_TYPE], { like: "both" })
          .build(),
      ];
      if (params.search) {
        defaultQueries.push(params.search);
      }
      params.search = defaultQueries.join(SearchBuilder.AND);
      try {
        const response = await findAllChildAccount(params);
        return toOptions(response.data);
      } catch (error) {
        return [];
      }
    },
    async getRevenueAccountList() {
      this.revenueAccountOptions = await this.fetchRevenueAccount();
    },
    async onSearchRevenueAccount(
      record: TruckingAccountReceivableProductState,
      value?: string
    ) {
      const { filterBy } = useCoa();
      record.isSearchRevenueAccount = true;
      const params = new RequestQueryParams();
      if (value) {
        params.search = filterBy({ code: value, description: value });
      }
      record.loadingRevenueAccount = true;
      record.revenueAccountOptions = await this.fetchRevenueAccount(params);
      record.loadingRevenueAccount = false;
    },
    async fetchIncomeTax(
      params: RequestQueryParamsModel = new RequestQueryParams()
    ) {
      const { findCollections, toOptions } = useTax();
      const queries: string[] = [
        new SearchBuilder()
          .push([
            "taxType",
            trimSpaceToUnderscore(TAX_TYPE.INCOME_TAX_RECEIVABLES),
          ])
          .build(),
      ];
      if (params?.search) {
        queries.unshift(params.search);
      }
      params.search = queries.join(SearchBuilder.AND);
      params.sorts = "createdDate:desc";
      try {
        const response = await findCollections(params);
        return toOptions(response.data);
      } catch (errror) {
        return [];
      }
    },
    async getIncomeTaxList() {
      this.incomeTaxOptions = await this.fetchIncomeTax();
    },
    async onSearchIncomeTax(
      record: TruckingAccountReceivableProductState,
      value?: string
    ) {
      const { filterBy } = useTax();
      record.isSearchIncomeTax = true;
      const params = new RequestQueryParams();
      if (value) {
        params.search = filterBy({ code: value, description: value });
      }
      try {
        record.loadingIncomeTax = true;
        record.incomeTaxOptions = await this.fetchIncomeTax(params);
      } finally {
        record.loadingIncomeTax = false;
      }
    },
    async fetchTaxCode(search?: string) {
      const { findAllVatOut, toOptions } = useTax();
      try {
        const response = await findAllVatOut(search);
        return toOptions(response.data);
      } catch (error) {
        return [];
      }
    },
    async getTaxCodeList() {
      this.taxCodeOptions = await this.fetchTaxCode();
    },
    async onSearchTaxCode(
      record: TruckingAccountReceivableProductState,
      value?: string
    ) {
      record.isSearchTaxCode = true;
      record.loadingTaxCode = true;
      record.taxCodeOptions = await this.fetchTaxCode(value);
      record.loadingTaxCode = false;
    },
    onChangePrice() {
      this.countProductPrice({
        products: this.formState.products,
        taxCalculation: this.formState.taxCalculation,
        additionalDiscount: this.formState.discountAmount,
        totalPrepaymentUsed: this.totalUsedPrepayment,
        isLuxury: this.formState.isLuxury,
        taxBaseVariable: this.formState.taxBaseVariable,
      });
      this.countTotalFooter(this.formState);
    },
    onChangeTaxCode(
      record: TruckingAccountReceivableProductState,
      value: LabelInValue
    ) {
      const options: Option<AccountingTaxResponseDto>[] = record.isSearchTaxCode
        ? record.taxCodeOptions
        : this.taxCodeOptions;
      const tax = options.find(item => item.value === value.key);
      record.taxRate = 0;
      if (tax) {
        record.taxRate = tax.meta?.rate ?? 0;
      }

      this.countProductPrice({
        products: this.formState.products,
        taxCalculation: this.formState.taxCalculation,
        additionalDiscount: this.formState.discountAmount,
        totalPrepaymentUsed: this.totalUsedPrepayment,
        isLuxury: this.formState.isLuxury,
        taxBaseVariable: this.formState.taxBaseVariable,
      });
      this.countTotalFooter(this.formState);
    },
    onChangeIncludePph(record: TruckingAccountReceivableProductState) {
      record.incomeTax = undefined;
    },
    setDefaultRevenueAccount(record: TruckingAccountReceivableProductState) {
      TruckingAccountReceivableUtils.setDefaultRevenueAccount(record);
    },
    setDefaultTaxCode(record: TruckingAccountReceivableProductState) {
      TruckingAccountReceivableUtils.setDefaultTaxCode(record);
    },
    onSelectChange(values: string[]) {
      this.selectedRowKeys = values;
    },
    addRow() {
      const newProduct: TruckingAccountReceivableProductState =
        buildTruckingAccountReceivableProductState();
      this.setDefaultRevenueAccount(newProduct);
      this.setDefaultTaxCode(newProduct);
      this.formState.products.push(newProduct);
    },
    deleteRow() {
      const { newSource, deletedRows } =
        useRemoveRows<TruckingAccountReceivableProductState>(
          this.formState.products,
          this.selectedRowKeys
        );
      this.selectedRowKeys = [];
      this.formState.products = [...newSource];
      deletedRows.forEach(item => {
        if (item.id) {
          this.formState.deletedInvoiceARLines.push(item);
        }
      });

      this.updateSalesOrderRelation();
      this.countProductPrice({
        products: this.formState.products,
        taxCalculation: this.formState.taxCalculation,
        additionalDiscount: this.formState.discountAmount,
        totalPrepaymentUsed: this.totalUsedPrepayment,
        isLuxury: this.formState.isLuxury,
        taxBaseVariable: this.formState.taxBaseVariable,
      });
      this.countTotalFooter(this.formState);
    },
    updateSalesOrderRelation() {
      // remove the sales order that we dont need
      // collect all sales orders reference from all products
      const salesOrderIds: Set<string> = new Set();
      for (const item of this.formState.products) {
        if (item.docReferenceId) {
          salesOrderIds.add(item.docReferenceId);
        }
      }
      // get all used sales orders
      const salesOrders: LabelInValue[] = [];
      for (const doc of this.formState.salesOrders) {
        if (salesOrderIds.has(doc.key)) {
          salesOrders.push(doc);
        }
      }

      this.formState.salesOrders = [...salesOrders];
    },
    async getCustomerTaxTypeList(params = new RequestQueryParams()) {
      const { findAll, toOptions } = useTaxInvoice();
      const defaultQuery: string[] = [
        new SearchBuilder().push(["revisionCode", "false"]).build(),
      ];
      if (params.search) {
        defaultQuery.push(params.search);
      }
      params.search = defaultQuery.join(SearchBuilder.AND);
      try {
        this.loading.customerTaxType = true;
        const response = await findAll(params);
        this.customerTaxTypeOptions = toOptions(response.data);
      } finally {
        this.loading.customerTaxType = false;
      }
    },
    onSearchCustomerTaxType(value?: string) {
      const { findAllBy } = useTaxInvoice();
      const params = new RequestQueryParams();
      if (value) {
        params.search = findAllBy({
          code: value,
        }).search;
      }
      this.getCustomerTaxTypeList(params);
    },
    onChangeCustomerTaxType() {
      this.formState.taxInvoiceNumber = "";
    },
    async onChangeInvoiceDate(value: Moment | null) {
      this.formState.accountingDate = value;
      this.formState.taxInvoiceDate = value;

      if (value) {
        const response = await this.getTaxBaseVariable({
          transactionDate: value.format(DATE_FORMAT_YYYY_MM_DD),
          isLuxury: this.formState.isLuxury,
        });
        this.formState.taxBaseVariable = response;
      } else {
        this.formState.taxBaseVariable = 1;
      }

      this.countProductPrice({
        products: this.formState.products,
        taxCalculation: this.formState.taxCalculation,
        additionalDiscount: this.formState.discountAmount,
        totalPrepaymentUsed: this.totalUsedPrepayment,
        isLuxury: this.formState.isLuxury,
        taxBaseVariable: this.formState.taxBaseVariable,
      });
      this.countTotalFooter(this.formState);
    },
    toggleDisableProductTax(state: boolean) {
      this.formState.products.forEach(
        (item: TruckingAccountReceivableProductState) => {
          item.disabledTax = state;
          if (state) {
            item.incomeTax = undefined;
            item.includePph = false;
            item.taxCode = undefined;
            item.taxAmount = new Decimal(0);
            item.taxRate = 0;
          }
        }
      );
    },
    async onChangeTaxCalculation(value: TAX_CALCULATION): Promise<void> {
      if (value === TAX_CALCULATION.NONE) {
        this.formState.customerTaxType = "";
        this.formState.taxIsUploaded = false;
        this.formState.taxInvoiceDate = null;
        this.formState.taxInvoiceNumber = "";
        this.toggleDisableProductTax(true);
      } else {
        this.toggleDisableProductTax(false);
      }

      if (this.isInclusiveNonLuxury) {
        this.setDefaultRowsSalesInclusiveRate();
      } else if (this.isInclusiveLuxury) {
        this.useTaxCodeAsInclusiveTaxCode();
      } else {
        this.resetInclusiveTaxCode();
      }

      this.countProductPrice({
        products: this.formState.products,
        taxCalculation: this.formState.taxCalculation,
        additionalDiscount: this.formState.discountAmount,
        totalPrepaymentUsed: this.totalUsedPrepayment,
        isLuxury: this.formState.isLuxury,
        taxBaseVariable: this.formState.taxBaseVariable,
      });
      this.countTotalFooter(this.formState);
    },
    handleResetPrepayment() {
      this.formState.prepayment.prepaymentLines.forEach(
        (item: TruckingAccountReceivableFormPrepaymentLineState) => {
          if (item.id) {
            this.formState.prepayment.deletedPrepaymentLineIds.push(item.id);
          }
        }
      );
      this.formState.prepayment.prepaymentLines = [];
      this.countProductPrice({
        products: this.formState.products,
        taxCalculation: this.formState.taxCalculation,
        additionalDiscount: this.formState.discountAmount,
        totalPrepaymentUsed: this.totalUsedPrepayment,
        isLuxury: this.formState.isLuxury,
        taxBaseVariable: this.formState.taxBaseVariable,
      });
      this.countTotalFooter(this.formState);
    },
    handleUsePrepayment(record: InvoicePrepaymentListResponseDto) {
      const prepayment: TruckingAccountReceivableFormPrepaymentLineState =
        TruckingAccountReceivableMapper.toPrepaymentLineState(record);
      this.formState.prepayment.prepaymentLines.push(prepayment);

      this.countProductPrice({
        products: this.formState.products,
        taxCalculation: this.formState.taxCalculation,
        additionalDiscount: this.formState.discountAmount,
        totalPrepaymentUsed: this.totalUsedPrepayment,
        isLuxury: this.formState.isLuxury,
        taxBaseVariable: this.formState.taxBaseVariable,
      });
      this.countTotalFooter(this.formState);
    },
    isPrepaymentUsed(record: InvoicePrepaymentListResponseDto): boolean {
      for (const prepayment of this.formState.prepayment.prepaymentLines) {
        if (prepayment.invoicePrepaymentId === record.id) {
          return true;
        }
      }

      return false;
    },
    onChangePrepaymentTable(pagination: APagination) {
      const { current, pageSize } = pagination;
      this.prepaymentPagination.page = current;
      if (pageSize !== this.prepaymentPagination.limit) {
        this.prepaymentPagination.page = DEFAULT_PAGE;
      }
      this.prepaymentPagination.limit = pageSize;
      this.findCustomerPrepayment({
        customerId: this.formState.customer?.key,
        branchId: this.formState.branch?.key,
        currencyCode: this.formState.currency?.label,
        pagination: this.prepaymentPagination,
      });
    },
    async getCustomerPrepaymentList(params?: RequestQueryParamsModel) {
      const { findAll } = useArPrepayment();
      this.loading.prepayment = true;
      const response = await findAll(params);
      this.dtPrepayment = response;
      this.loading.prepayment = false;
    },
    findCustomerPrepayment(data: {
      customerId: string | undefined;
      branchId: string | undefined;
      currencyCode: string | undefined;
      pagination?: { page: number; limit: number };
    }) {
      if (!data.customerId || !data.branchId || !data.currencyCode) {
        this.dtPrepayment.currentPage = 0;
        this.dtPrepayment.data = [];
        this.dtPrepayment.totalElements = 0;
        this.dtPrepayment.totalPages = 0;
        return;
      }
      const params = new RequestQueryParams();
      if (data.pagination) {
        params.limit = data.pagination.limit;
        params.page = data.pagination.page;
      }
      params.search = new SearchBuilder()
        .push(["customer.secureId", data.customerId])
        .and()
        .push(["branchWarehouse.secureId", data.branchId])
        .and()
        .push(["priceCurrency.currencyCode", data.currencyCode])
        .build();

      this.getCustomerPrepaymentList(params);
    },
    handleResetSalesOrder() {
      this.formState.salesOrders = [];
      this.handleResetProducts();
    },
    handleResetProducts() {
      for (const product of this.formState.products) {
        if (product.id) {
          this.formState.deletedInvoiceARLines.push(product.id);
        }
      }
      this.formState.products = [];
    },
    handleDeleteUsedPrepayment(
      record: TruckingAccountReceivableFormPrepaymentLineState
    ) {
      if (record.id) {
        this.formState.prepayment.deletedPrepaymentLineIds.push(record.id);
      }
      const removeIndex = this.formState.prepayment.prepaymentLines.findIndex(
        (item: TruckingAccountReceivableFormPrepaymentLineState) =>
          item.invoicePrepaymentId === record.invoicePrepaymentId
      );
      if (removeIndex >= 0) {
        this.formState.prepayment.prepaymentLines.splice(removeIndex, 1);
      }
      this.countProductPrice({
        products: this.formState.products,
        taxCalculation: this.formState.taxCalculation,
        additionalDiscount: this.formState.discountAmount,
        totalPrepaymentUsed: this.totalUsedPrepayment,
        isLuxury: this.formState.isLuxury,
        taxBaseVariable: this.formState.taxBaseVariable,
      });
      this.countTotalFooter(this.formState);
    },
    handleRefreshPrepayment() {
      this.findCustomerPrepayment({
        customerId: this.formState.customer?.key,
        branchId: this.formState.branch?.key,
        currencyCode: this.formState.currency?.label,
      });
    },
    handleStatusDetailView(key: "prepayment" | "creditMemo" | "paidStatus") {
      let data: TruckingAccountReceivableFormStatusDetailInvoiceState[] = [];
      let title = "";
      if (key === "prepayment") {
        data = this.formState.statusDetail.prepaymentLines;
        title = this.$t("lbl_prepayment_used").toString();
      } else if (key === "creditMemo") {
        data = this.formState.statusDetail.creditMemoLines;
        title = this.$t("lbl_credit_memo").toString();
      } else if (key === "paidStatus") {
        data = this.formState.statusDetail.invoiceReceipts;
        title = this.$t("lbl_paid_status").toString();
      }
      this.modalStatus.title = title;
      this.modalStatus.show = true;
      this.modalStatus.data = data;
    },
    handleCloseInvoiceStatusModal() {
      this.modalStatus.show = false;
      this.modalStatus.title = "";
      this.modalStatus.data = [];
    },
    handleViewDiscount(record: TruckingAccountReceivableProductState) {
      this.modalDiscount.show = true;
      const data: TruckingAccountReceivableFormDiscountState = {
        key: record.key,
        unitCode: record.unitCode?.label ?? "",
        serialNumber: record.serialNumber,
        equipment: record.equipment,
        brand: record.brand,
        type: record.type,
        spec: record.spec,
        baseAmount: record.baseAmount.toNumber(),
        discountAmount: record.discountAmount,
        discountPercent: record.discountPercent,
        gross: new Decimal(record.price ?? 0)
          .times(record.quantity ?? 0)
          .toNumber(),
      };
      this.modalDiscount.data = { ...data };
    },
    handleAddDiscount({
      formState,
      key,
    }: {
      formState: { discountAmount: number; discountPercent: number };
      key: string;
    }) {
      const record: TruckingAccountReceivableProductState | undefined =
        this.formState.products.find(
          (product: TruckingAccountReceivableProductState) => {
            return product.key === key;
          }
        );
      if (record) {
        record.discountAmount = formState.discountAmount ?? 0;
        record.discountPercent = formState.discountPercent ?? 0;
      }

      this.countProductPrice({
        products: this.formState.products,
        taxCalculation: this.formState.taxCalculation,
        additionalDiscount: this.formState.discountAmount,
        totalPrepaymentUsed: this.totalUsedPrepayment,
        isLuxury: this.formState.isLuxury,
        taxBaseVariable: this.formState.taxBaseVariable,
      });
      this.countTotalFooter(this.formState);
    },
    onChangeAdditionalDiscount(value: number | null, isPercent = false) {
      this.formState.discountAmount = 0;
      this.formState.discountPercent = 0;
      if (value) {
        const totalGross = TruckingAccountReceivableUtils.countTotalGross(
          this.formState.products
        );
        const { amount, percent } =
          TruckingAccountReceivableUtils.countDiscount(
            value,
            totalGross,
            isPercent
          );
        this.formState.discountAmount = amount;
        this.formState.discountPercent = percent;
      }
      this.countProductPrice({
        products: this.formState.products,
        taxCalculation: this.formState.taxCalculation,
        additionalDiscount: this.formState.discountAmount,
        totalPrepaymentUsed: this.totalUsedPrepayment,
        isLuxury: this.formState.isLuxury,
        taxBaseVariable: this.formState.taxBaseVariable,
      });
      this.countTotalFooter(this.formState);
    },
    countProductPrice({
      taxCalculation,
      additionalDiscount = 0,
      totalPrepaymentUsed = 0,
      isLuxury,
      taxBaseVariable = 1,
      ...args
    }: {
      products: TruckingAccountReceivableProductState[];
      taxCalculation: TAX_CALCULATION;
      additionalDiscount?: number;
      totalPrepaymentUsed?: number;
      isLuxury: boolean;
      taxBaseVariable?: number;
    }) {
      const { round } = useCalculator();
      const MAX_PRECISION = 14;
      let sumOfGrossValue = 0;
      const discountHeader: number = additionalDiscount;
      const isInclusive: boolean = taxCalculation === TAX_CALCULATION.INCLUSIVE;
      const isExclusive: boolean = taxCalculation === TAX_CALCULATION.EXCLUSIVE;
      const totalAppliedPrepayment: Decimal = new Decimal(totalPrepaymentUsed);

      sumOfGrossValue = args.products.reduce((left: number, right) => {
        const gross = new Decimal(right.price).times(right.quantity);
        return new Decimal(left).plus(gross).toNumber();
      }, 0);

      args.products.forEach(product => {
        product.isRounded = false;
        const gross = new Decimal(product.price ?? 0).times(
          product.quantity ?? 0
        );
        product.grossValue = gross.toNumber();
        product.proRateRatio = gross
          .dividedBy(sumOfGrossValue)
          .todp(14, Decimal.ROUND_FLOOR)
          .toNumber();
        product.proRateAdditionalDiscountAmount = new Decimal(
          product.proRateRatio
        )
          .times(discountHeader)
          .toNumber();
        const proRatePrepaymentAmount: Decimal = totalAppliedPrepayment.times(
          product.proRateRatio
        );

        const grossAfterDiscount = new Decimal(product.grossValue)
          .minus(product.discountAmount)
          .minus(product.proRateAdditionalDiscountAmount)
          .minus(proRatePrepaymentAmount);
        product.grossAfterDiscount = grossAfterDiscount;

        if (isExclusive) {
          const baseAmount = round(
            new Decimal(taxBaseVariable).times(grossAfterDiscount)
          );
          product.baseAmount = baseAmount;
          const taxRate = new Decimal(product.taxRate ?? 0).dividedBy(100);
          product.taxAmount = round(baseAmount.times(taxRate));

          if (isLuxury) {
            product.subtotal = round(baseAmount.plus(product.taxAmount));
          } else {
            product.subtotal = round(
              product.grossAfterDiscount.plus(product.taxAmount)
            );
          }
        } else if (isInclusive) {
          const inclusiveRate: number = isLuxury
            ? (product.taxRate ?? 0)
            : product.inclusiveTaxRate;
          const inclusiveRateDivider = new Decimal(inclusiveRate)
            .dividedBy(100)
            .plus(1);
          const grossAfterDiscountExcludeTax = round(
            grossAfterDiscount.dividedBy(inclusiveRateDivider),
            Decimal.ROUND_HALF_EVEN,
            MAX_PRECISION
          );
          const baseAmount = round(
            new Decimal(taxBaseVariable).times(grossAfterDiscountExcludeTax),
            Decimal.ROUND_HALF_EVEN,
            MAX_PRECISION
          );
          product.grossAfterDiscount = grossAfterDiscountExcludeTax;
          product.baseAmount = baseAmount;

          const taxRate = new Decimal(product.taxRate ?? 0).dividedBy(100);
          product.taxAmount = round(
            baseAmount.times(taxRate),
            Decimal.ROUND_HALF_EVEN,
            MAX_PRECISION
          );

          product.subtotal = round(
            grossAfterDiscountExcludeTax.plus(product.taxAmount),
            Decimal.ROUND_HALF_EVEN
          );
        } else {
          product.taxAmount = new Decimal(0);
          product.baseAmount = grossAfterDiscount;
          product.subtotal = product.baseAmount;
        }
      });
    },
    countTotalFooter(state: TruckingAccountReceivableFormState) {
      state.totalGross = this.totalGross as number;
      state.totalTax = this.totalTax as number;
      state.totalUsedPrepayment = this.totalUsedPrepayment as number;
      state.grandTotal = this.grandTotal as number;
    },
    handleRounding(): void {
      this.loading.rounding = true;
      try {
        this.formState.products.forEach(product => {
          const roundedTax = RoundingUtils.roundHalfUp(
            new Decimal(product.taxAmount),
            0
          );
          const taxDelta = roundedTax.minus(new Decimal(product.taxAmount));
          product.taxAmount = roundedTax;
          product.subtotal = product.subtotal.plus(taxDelta);
          product.isRounded = true;
        });
        this.countTotalFooter(this.formState);
      } catch {
        this.showNotifError("notif_process_fail");
      } finally {
        this.loading.rounding = false;
      }
    },
    handleBack() {
      this.showConfirmationLeavePage(() => {
        this.$router.push({ name: "trucking.account-receivable.list" });
      });
    },
    async fetchUnitCodeList(params?: RequestQueryParamsModel) {
      const { findAll, toOptions } = useProduct();
      try {
        const response = await findAll(params);
        return toOptions(response.data);
      } catch (error) {
        return [];
      }
    },
    async getUnitCodeList() {
      const params = new RequestQueryParams();
      params.search = new SearchBuilder()
        .push(["type", NON_STOCKABLE])
        .or()
        .push(["type", SERVICE])
        .build();
      this.unitCodeOptions = await this.fetchUnitCodeList(params);
    },
    async onSearchUnitCode(
      record: TruckingAccountReceivableProductState,
      value?: string
    ) {
      record.isSearchUnitCode = true;
      record.loadingUnitCode = true;
      const params = new RequestQueryParams();
      if (value) {
        params.search = new SearchBuilder()
          .push(["description", value])
          .or()
          .push(["code", value])
          .and()
          .push(["type", NON_STOCKABLE])
          .or()
          .push(["type", SERVICE])
          .build();
      }
      const response = await this.fetchUnitCodeList(params);
      record.unitCodeOptions = response;
      record.loadingUnitCode = false;
    },
    async getTaxBaseVariable(params: TaxBaseVariableParams) {
      try {
        const response = await taxBaseVariableService.getVariable(params);
        return response.value ?? 1;
      } catch {
        return 1;
      }
    },
    async onChangeIsLuxury(val: boolean) {
      if (this.formState.invoiceDate) {
        const response = await this.getTaxBaseVariable({
          transactionDate: this.formState.invoiceDate.format(
            DATE_FORMAT_YYYY_MM_DD
          ),
          isLuxury: val,
        });
        this.formState.taxBaseVariable = response;
      } else {
        this.formState.taxBaseVariable = 1;
      }

      if (this.isInclusiveNonLuxury) {
        this.setDefaultRowsSalesInclusiveRate();
      } else if (this.isInclusiveLuxury) {
        this.useTaxCodeAsInclusiveTaxCode();
      } else {
        this.resetInclusiveTaxCode();
      }

      this.countProductPrice({
        products: this.formState.products,
        taxCalculation: this.formState.taxCalculation,
        additionalDiscount: this.formState.discountAmount,
        totalPrepaymentUsed: this.totalUsedPrepayment,
        isLuxury: this.formState.isLuxury,
        taxBaseVariable: this.formState.taxBaseVariable,
      });
      this.countTotalFooter(this.formState);
    },
    async getDefaultSalesInclusiveRate() {
      const { findByKey } = usePreferences();
      try {
        const preference = findByKey("feature_sales_inclusive_tax_rate");
        if (!preference || !preference.value) return;
        const taxRate = await useTaxRate(preference.value);
        this.salesInclusiveTax.id = preference.value;
        this.salesInclusiveTax.name = preference.name;
        this.salesInclusiveTax.rate = taxRate;
      } catch {
        this.salesInclusiveTax.id = "";
        this.salesInclusiveTax.name = "";
        this.salesInclusiveTax.rate = 0;
      }
    },
    resetInclusiveTaxCode(): void {
      this.formState.products.forEach(
        (product: TruckingAccountReceivableProductState) => {
          product.inclusiveTaxRate = 0;
          product.inclusiveTax = undefined;
        }
      );
    },
    useTaxCodeAsInclusiveTaxCode(): void {
      this.formState.products.forEach(
        (product: TruckingAccountReceivableProductState) => {
          product.inclusiveTaxRate = product.taxRate;
          product.inclusiveTax = product.taxCode;
        }
      );
    },
    setDefaultRowsSalesInclusiveRate(): void {
      this.formState.products.forEach(
        (product: TruckingAccountReceivableProductState) => {
          product.inclusiveTaxRate = this.salesInclusiveTax.rate;
          if (this.salesInclusiveTax.id) {
            product.inclusiveTax = {
              label: this.salesInclusiveTax.name,
              key: this.salesInclusiveTax.id,
            };
          }
        }
      );
    },
    async getInclusiveTaxCodeList(): Promise<void> {
      this.inclusiveTaxCodeOptions = await this.fetchTaxCode();
    },
    async onSearchInclusiveTaxCode(
      record: TruckingAccountReceivableProductState,
      value?: string
    ): Promise<void> {
      record.isSearchInclusiveTaxCode = true;
      record.loadingInclusiveTaxCode = true;
      record.inclusiveTaxCodeOptions = await this.fetchTaxCode(value);
      record.loadingInclusiveTaxCode = false;
    },
    onChangeInclusiveTaxCode(
      record: TruckingAccountReceivableProductState,
      value: LabelInValue
    ) {
      const options: Option<AccountingTaxResponseDto>[] =
        record.isSearchInclusiveTaxCode
          ? record.inclusiveTaxCodeOptions
          : this.inclusiveTaxCodeOptions;
      const tax = options.find(item => item.value === value.key);
      record.inclusiveTaxRate = 0;
      if (tax) {
        record.inclusiveTaxRate = tax.meta?.rate ?? 0;
      }

      this.countProductPrice({
        products: this.formState.products,
        taxCalculation: this.formState.taxCalculation,
        additionalDiscount: this.formState.discountAmount,
        totalPrepaymentUsed: this.totalUsedPrepayment,
        isLuxury: this.formState.isLuxury,
        taxBaseVariable: this.formState.taxBaseVariable,
      });
      this.countTotalFooter(this.formState);
    },
  },
});
